var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shortTime"},[_c('div',{staticClass:"publishTime"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"publishContent"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }